export default __webpack_public_path__ + "static/media/putting-money-into-srs.ac2ad6bb.svg";